import { ref, computed } from "vue";
import { useStore } from "@/store";
const store = useStore();
const activeRowModal: any = ref({ data: null });
import { GeneralActionTypes } from "@/store/modules/general/action-types";

const data = {
    filter: {
        title: "",
        pageName: "",
        genre: "",
        ignoreSaveFilter: true,
        noDateSelect: true,
        hideFilter: false,
        filters: [
        ],
    },
    header: {
        navigation: [

        ],
        buttonPosition: "pr-4 justify-content-between",
        buttons: [

        ],
    },
    component: {
        type: "ag-table",
        options: {
            columns: [
                {
                    label: "FILE EXTENSION",
                    field: "fileTypePolicyName",
                    sortable: false,
                    display: (row: any) => {
                        const fileExtension = row.fileExtension ?? "";
                        const fileTypePolicyName = row.fileTypePolicyName ?? "";
                        let html = "<div class='d-flex flex-column align-items-start'>";
                        html += "<span style='font-weight: bold; color: #01172F;'>" + fileExtension + "</span>"
                        html += "<span style='color: #01172F;'>" + fileTypePolicyName + "</span>"
                        if (row.enabled === false) {
                            html += "<div class='d-flex align-items-center' style='margin-top:10px'><i class='ag-icon ag-icon_warning_filled' style='font-size:0.8em !important;'></i><span style='font-size:0.7em; color:#636363;'>This rule is disabled and will not be published</span></div>";
                        }
                        html += "</div>";
                        return html;
                    },
                    width: "35%",
                },
                {
                    label: "APPLICATION",
                    field: "bReadExtFromRegistry",
                    display: (row: any) => {
                        const appList = row.fileExtensionApps?.map((item: any) => {
                            const displayValue = item.applicationPath;
                            return displayValue;
                        }) || [];
                        return `<ul style="padding-left: 1.25rem; margin: 0; list-style-type: none; color: #01172F;">
        ${appList.map((app: string) => `<li>${app}</li>`).join("")}
      </ul>`;
                    },
                    sortable: false,
                    width: "25%",
                },
                {
                    label: "ACCESS CONTROL",
                    field: "driverActionOverride",
                    sortable: true,
                    jsSort: true,
                    display: (row: any) => {
                        const accessControl = row.driverActionOverride ?? "";
                        return `<span style='color: #01172F;'>${accessControl}</span>`;
                    },
                    width: "25%",
                },
                {
                    label: "ACTION",
                    field: "commands",
                    components: [
                        {
                            component: "appGroupTableEditComponent",
                        },
                        {
                            component: "copyAction",
                            class: "mr-2 ml-2",
                        },
                        {
                            component: "appGroupDeleteComponent",
                        },
                    ],
                    width: "120px",
                },
            ],
            rows: [],
            total: 0,
            sortable: {
                order: "",
                sort: "asc",
            },
            page: 0,
            pageSize: 0,
            isLoading: true,
            showPagination: false,
            dateFilter: false,
            zebra: true,
            separateBorders: true,
            editOnRowClick: true,
            fetchTable: (options: any) => {
                store.dispatch(GeneralActionTypes.GET_ALL_FILE_TYPES_POLICIES, {
                    options: options,
                    filters: {}
                });
            },
        },
    },

};

export default data;
